import React from 'react';
import { Button } from '@material-ui/core';

const ConnectGoogleAccount = () => (
	<Button
		variant='contained'
		disableElevation
		href='/auth/google'
		style={{
			textTransform: 'none',
			padding: '10px 18px',
			fontSize: '0.95rem',
			borderRadius: 10,
			fontWeight: 700,
			backgroundColor: '#c655d6',
			color: '#fff',
		}}
	>
		Connect Google Account
	</Button>
);

export default ConnectGoogleAccount;



// WEBPACK FOOTER //
// ./src/components/add_accounts/ConnectGoogleAccount.js